import { Component, PLATFORM_ID, Inject } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
	SupabaseService
} from '@app/core/services';
// ** service
import { LayoutService } from '@app/core/services/layout.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// ** rxjs
import { finalize, map, switchMap, tap, catchError } from 'rxjs/operators';
import { of, Observable, from, EMPTY } from 'rxjs';
import * as moment from 'moment';
import { MessageService } from '@app/core/services';
import { Router } from '@angular/router';

@Component({
	selector: 'app-sign-in',
	templateUrl: './sign-in.component.html',
	styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent {
	isBrowser: boolean;

	mode = 'list'; // list || detail || success
	buyerForm: FormGroup = this.formBuilder.group({
		name: ['', Validators.required],
		nickName: [''],
		email: ['', [Validators.required, Validators.email]],
		phone: ['', Validators.required],
		bankAccount: ['', Validators.required],
		'711Name': ['', Validators.required],
		pwd: ['']
	});

	constructor(
		@Inject(DOCUMENT) private document: Document,
		@Inject(PLATFORM_ID) private platformId,
		private supabaseService: SupabaseService,
		private formBuilder: FormBuilder,
		public layoutService: LayoutService,
		public messageService: MessageService,
		private router: Router
	) {
		this.isBrowser = isPlatformBrowser(this.platformId);
		this.layoutService.setPageLoading(false);
		this.init();
	}

	init() {
		of(null)
			.pipe(
				tap(() => this.layoutService.setPageLoading(true)),
				switchMap(() => this.getSession$()),
				finalize(() => this.layoutService.setPageLoading(false))
			)
			.subscribe({
				next: (res) => {
					console.log('subscribe', res);
					if (!!res.session) this.router.navigate(['/']);
				},
				error: (err) => {
					switch(err.code) {
						default:
							this.messageService.add({
								severity: 'error',
								summary: `錯誤`,
								detail: '請聯絡大阿姨團隊',
								icon: 'bounce animated',
								life: 5000,
							});
							break;
					}
				}
			});
	}

	// 按下登入
	signIn() {
		of(null)
			.pipe(
				tap(() => this.layoutService.setPageLoading(true)),
				switchMap(() => this.signIn$(this.buyerForm.value.email, this.buyerForm.value.pwd)),
				switchMap((signInRes) => {
					return this.getProfile$(signInRes.user.id).pipe(
						map((profileRes) => ({
							signIn: signInRes,
							profile: profileRes
						}))
					);
				}),
				finalize(() => this.layoutService.setPageLoading(false))
			)
			.subscribe({
				next: (res) => {
					if (this.isBrowser) localStorage.setItem('profile', JSON.stringify(res.profile[0]));
					this.messageService.add({
						severity: 'success',
						summary: `成功`,
						detail: '登入成功',
						icon: 'bounce animated',
						life: 5000,
					});
					setTimeout(() => {
						this.router.navigate(['/']);
					}, 3000)
				},
				error: (err) => {
					switch(err.code) {
						case 'invalid_credentials':
							this.messageService.add({
								severity: 'error',
								summary: `錯誤`,
								detail: '帳號密碼輸入錯誤，請重新嘗試',
								icon: 'bounce animated',
								life: 5000,
							});
							break;
						case 'email_not_confirmed':
							this.messageService.add({
								severity: 'error',
								summary: `錯誤`,
								detail: '尚未點擊信件驗證連結',
								icon: 'bounce animated',
								life: 5000,
							});
							break;
						default:
							this.messageService.add({
								severity: 'error',
								summary: `錯誤`,
								detail: '請聯絡大阿姨團隊',
								icon: 'bounce animated',
								life: 5000,
							});
							break;
					}
				}
			});
	}

	// --------------------------- API ---------------------------
	// - 登入
	signIn$(email: string, pwd: string): Observable<any> {
		return from(this.supabaseService.signIn(email, pwd)).pipe(
			map(({ data, error }) => {
				if (error) throw error;
				return data;
			})
		);
	}

	// - 取得個人資料
	getProfile$(userInfo: any): Observable<any> {
		return from(this.supabaseService.getProfile(userInfo)).pipe(
			map(({ data, error }) => {
				if (error) throw error;
				return data;
			})
		);
	}

	// - 取得登入狀態
	getSession$(): Observable<any> {
		return from(this.supabaseService.getSession()).pipe(
			map(({ data, error }) => {
				if (error) throw error;
				return data;
			})
		);
	}
}
